import React from 'react';

import {
  Grid,
  Button,
} from '@material-ui/core';
import NextIcon from '@material-ui/icons/ChevronRight';
import PrevIcon from '@material-ui/icons/ChevronLeft';

import InputField from '../../common/components/inputField';
import * as asyncSelectData from '../../common/asyncSelectData';

import classes from '../../css/getCSS';
import * as constants from '../../config/constants';
import pdfPreviewImage from '../../assets/img/pdf_preview.jpg';
import DeleteIcon from '@material-ui/icons/DeleteOutline';


const lifestyleInfoForm = (props) => {
  console.log('lifestyleInfoForm===props', props);

  // let files = null;
  // files = props.filesReport.map((file) => {
  //   console.log('lifestyleInfoForm===files', file);
  //   let url = null;
  //   if (file.file_type === 'IMAGE') {
  //     url = constants.BASE_URL + file.thumbnail;
  //   } else {
  //     url = pdfPreviewImage;
  //   }
  //   let removeButton = (
  //     <Button
  //       variant="outlined"
  //       size="small"
  //       onClick={() => props.deleteFile(file.id)}
  //       className={classes.roundIconButton}
  //     >
  //       <DeleteIcon style={{ fontSize: '16px' }} />
  //     </Button>
  //   );
  //   if (props.editMode && props.filesReport.length === 1) {
  //     removeButton = null;
  //   }
  //   return (
  //     <Grid item md={3} xs={6} sm={3} align="center" key={file.id}>
  //       <img
  //         src={url}
  //         alt={file.file_type}
  //         className={classes.formImage}
  //       />
  //       <br />
  //       {removeButton}
  //     </Grid>
  //   );
  // });
  // console.log('lifestyleInfoForm===files', files);

  let buttons = (
    <Button variant="contained" color="primary" type="submit" size="large" className={classes.Button}>
      Update
    </Button>
  );

  if (!props.editMode) {
    buttons = (
      <React.Fragment>
        <Button onClick={() => props.redirectToStep(props.prevStep)} variant="contained" color="primary" size="large" className={classes.Button} style={{ marginRight: '10px' }}>
          <PrevIcon />
          Back
        </Button>
        <Button variant="contained" color="primary" type="submit" size="large" className={classes.Button}>
          Next
          <NextIcon />
        </Button>
      </React.Fragment>
    );
  }

  let blockquote = null;

  if (!props.editMode) {
    blockquote = (
      <React.Fragment>
        <blockquote className={classes.profileFormQuote}>
          Tell us more about your lifestyle.
        </blockquote>
        <br /><br />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      {blockquote}
      <Grid container spacing={24}>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="body_type"
            config={props.inputs.body_type}
            changed={event => props.inputChangedHandler(event, 'body_type')}
            loadOptions={() => asyncSelectData.getOptionConstants('body_type')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="physical_disabilities"
            config={props.inputs.physical_disabilities}
            changed={event => props.inputChangedHandler(event, 'physical_disabilities')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="diet"
            config={props.inputs.diet}
            changed={event => props.inputChangedHandler(event, 'diet')}
            loadOptions={() => asyncSelectData.getOptionConstants('diet')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="thalassemia"
            config={props.inputs.thalassemia}
            changed={event => props.inputChangedHandler(event, "thalassemia")}
            loadOptions={() => asyncSelectData.getOptionConstants("thalassemia")}
          />
        </Grid>
        {/*<Grid item md={6} xs={12} sm={6}>*/}
        {/*  <InputField*/}
        {/*    id="smoke"*/}
        {/*    config={props.inputs.smoke}*/}
        {/*    changed={event => props.inputChangedHandler(event, 'smoke')}*/}
        {/*    loadOptions={() => asyncSelectData.getOptionConstants('smoke')}*/}
        {/*  />*/}
        {/*</Grid>*/}
        {/*<Grid item md={6} xs={12} sm={6}>*/}
        {/*  <InputField*/}
        {/*    id="drink"*/}
        {/*    config={props.inputs.drink}*/}
        {/*    changed={event => props.inputChangedHandler(event, 'drink')}*/}
        {/*    loadOptions={() => asyncSelectData.getOptionConstants('drink')}*/}
        {/*  />*/}
        {/*</Grid>*/}
      </Grid>
      <br />
      {buttons}
    </React.Fragment>
  );
};

export default lifestyleInfoForm;



// WEBPACK FOOTER //
// ./src/profile/components/LifestyleInfoForm.js